
import DcddUserTable from "./page/DcddUserTable";

const Users: React.FC = () => {
    return(
        <>
        <DcddUserTable/>
        </>
    )
};
export default Users;